<template>
    <div class="lxtx-loading l-container-class" :class="['loading-'+(show?'show':'hide')]">
        <div class="loading-container">
            <div>
                <div class="img-container">
                    <img
                        class="loading-img"
                        src="@/assets/images/lxtx.gif"
                        alt="loading"
                        title="加载中"
                    />
                </div>
                <div class="loading-text">{{loadingtext}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Loading',
    components: {},
    props: {
        show: Boolean,
        loadingtext: {
            type: String,
            default: '拼命加载中...'
        }
    }
}
</script>
<style lang='stylus' scoped>
.loading-container
    // display: inline-block;
    position: fixed
    top: 0
    right: 0
    bottom: 0
    left: 0
    z-index: 1110
    background: #fff
    display: flex
    align-items: center
    justify-content: center
    text-align: center
    img
        width: 64px
.loading-show
    z-index: 9999
    background: #fff
    position: fixed
    top: 0
    right: 0
    bottom: 0
    left: 0
.loading-hide
    display: none
</style>
